import type { AddressSchema, CompanyDataSchema } from "../api-types/company_data_schemas";

// Falls back to the registered company country (`data.country`) when the address doesn't
// carry its own. The registered address has no editable country field — it always uses
// the company's registered jurisdiction. The operating address can be anywhere in the
// world (see `CompanyInfoAddressForm`), so we keep whatever country it brought along.
export const prepAddress = (data: CompanyDataSchema, name: string): AddressSchema | null => {
  const address = data[name];
  if (Object.values(address).every((x) => x == null || x === "")) {
    return null;
  }
  return { ...address, country: address.country || data.country };
};
